import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {SessionService} from '../state/session.service';

export const adminAuthGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (session.authToken && session.isAdmin()) {
    return true;
  }

  return router.createUrlTree(['/conversation-overview']);
};
